import findLast from 'lodash/findLast';
import { logger } from '@fiverr-private/obs';
import { isBrowser } from '../utils';
import { CodeActivationTriggerCallback } from '../types';
import { globalGrafanaReporter } from '../events';
import { EVENTS } from './constants';
import { codeActivationEventBus } from './codeActivationEventBus';

/**
 * Should be used only inside of layout. Not for external use.
 */
export const registerCodeActivationListener = (callback: CodeActivationTriggerCallback) => {
    try {
        globalGrafanaReporter.count('identification.%{platform}.activation.listener_registration.start');

        if (!isBrowser()) {
            throw new Error('[Code Activation] Cannot register listener on server side - browser environment required');
        }

        const hasRegisteredListenerEvent = codeActivationEventBus.log.some(
            ({ event }) => event === EVENTS.REGISTER_CODE_ACTIVATION_LISTENER
        );

        if (hasRegisteredListenerEvent) {
            throw new Error('[Code Activation] Listener already registered - cannot register multiple listeners');
        }

        codeActivationEventBus.on(EVENTS.SHOW_CODE_ACTIVATION_MODAL, callback);

        codeActivationEventBus.emit(EVENTS.REGISTER_CODE_ACTIVATION_LISTENER);

        const showCodeActivationModalRegisteredEvent = findLast(codeActivationEventBus.log, {
            event: EVENTS.SHOW_CODE_ACTIVATION_MODAL,
        });

        if (showCodeActivationModalRegisteredEvent) {
            callback(showCodeActivationModalRegisteredEvent.args);
        }

        globalGrafanaReporter.count('identification.%{platform}.activation.listener_registration.success');
    } catch (error) {
        globalGrafanaReporter.count('identification.%{platform}.activation.listener_registration.failed');

        logger.warn('[Code Activation] Failed to register listener', {
            error: error instanceof Error ? error.message : 'Unknown error',
            event: EVENTS.REGISTER_CODE_ACTIVATION_LISTENER,
        });
    }
};

/**
 * Should be used only inside of layout. Not for external use.
 */
export const unregisterCodeActivationListener = (callback: CodeActivationTriggerCallback) => {
    try {
        globalGrafanaReporter.count('identification.%{platform}.activation.listener_unregistration.start');

        if (!isBrowser()) {
            throw new Error(
                '[Code Activation] Cannot unregister listener on server side - browser environment required'
            );
        }

        codeActivationEventBus.off(EVENTS.SHOW_CODE_ACTIVATION_MODAL, callback);

        codeActivationEventBus.clearLog();

        globalGrafanaReporter.count('identification.%{platform}.activation.listener_unregistration.success');
    } catch (error) {
        globalGrafanaReporter.count('identification.%{platform}.activation.listener_unregistration.failed');

        logger.warn('[Code Activation] Failed to unregister listener', {
            error: error instanceof Error ? error.message : 'Unknown error',
            event: EVENTS.REGISTER_CODE_ACTIVATION_LISTENER,
        });
    }
};
